import { ROUTES } from "../../../routes";

// The public downloads catalog. Everything the developer site distributes is
// described here — the public list, the detail pages and the landing section
// all read this one array, so adding a download is a single entry.
//
// `access: "signin"` means the artifact itself sits behind the protected app
// (org-scoped S3, board-matched firmware); the detail page is still public so
// the download is findable and indexable before anyone signs in.
export const DOWNLOAD_CATALOG = [
  {
    slug: "ardupilot-firmware",
    category: "Firmware",
    title: "ArduPilot flight-control firmware",
    tagline:
      "Vecros-hosted ArduPilot builds, matched to the board you have plugged in and flashed straight from the browser.",
    access: "signin",
    action: { label: "Open the flasher", href: ROUTES.firmwareFlasher },
    meta: [
      { label: "Format", value: ".apj firmware image" },
      { label: "Delivery", value: "Web Serial — no installer" },
      { label: "Verification", value: "SHA-256, checked before write" },
      { label: "Vehicles", value: "Copter · Plane · Rover · Sub" },
    ],
    description: [
      "The flasher talks to your flight controller over USB using Web Serial, reads the board ID out of the bootloader and only offers the builds that physically fit that board — so there is no version-and-board matrix to work through by hand.",
      "Every image is hashed after download and compared against the digest the catalog advertises. A truncated or tampered file is refused rather than written to the board.",
    ],
    includes: [
      "Stable, beta and dev builds per vehicle type",
      "Board detection straight from the bootloader",
      "SHA-256 verification before anything is written",
      "Flashing progress and erase/write/verify stages in the browser",
    ],
    requirements: [
      "A Chromium-based browser (Chrome, Edge, Opera) — Web Serial is not in Safari or Firefox",
      "A flight controller connected over USB",
    ],
  },
  {
    slug: "organization-downloads",
    category: "Assets",
    title: "Organization downloads",
    tagline:
      "Release bundles, datasheets and files shared with your organization, served over expiring signed links.",
    access: "signin",
    action: { label: "Browse your files", href: ROUTES.downloads },
    meta: [
      { label: "Contents", value: "Set per organization" },
      { label: "Delivery", value: "Expiring signed links" },
      { label: "Scope", value: "Visible to your organization only" },
    ],
    description: [
      "Files your organization has been given access to — firmware bundles, hardware datasheets, integration kits and release archives — in a browsable folder tree.",
      "Nothing here is public. Each download is handed out as a short-lived signed URL issued to your account at the moment you click it.",
    ],
    includes: [
      "Folder tree of everything shared with your organization",
      "Per-file download over an expiring signed link",
      "Sizes and last-modified dates for each object",
    ],
    requirements: ["A Vecros developer account with access to the organization"],
  },
];

export const findDownload = (slug) => DOWNLOAD_CATALOG.find((d) => d.slug === slug);

export const DOWNLOADS_PUBLIC_PATH = `${ROUTES.downloads}/public`;
export const downloadPath = (slug) => `${DOWNLOADS_PUBLIC_PATH}/${slug}`;
